import { defineStore } from "pinia";

export const useCatalogPublicationLibraryStore = defineStore("CatalogPublicationLibraryStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationLibrary(libraryId) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/catalog/libraries/${libraryId}`);
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    }
  }
});
